import { connect } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import DraggableItem from '../../../../../components/Editor/Thumbnails/Column/DraggableItem';
import { ThumbnailData } from '../../../../../components/Editor/Thumbnails/constants';

import { getPageHtmlPath, getClientAndResourceIds } from '../../../utils/helpers';
import UrlUtils from '../../../../../utils/url';
import SelectionManager from '../../../../../utils/selectionManager';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		galleryInfos: { config: galleryConfig },
		editor: {
			thumbnails,
			pagesController: { currentSpreadIndex, spreads },
			configs: {
				generalData: { editablePublication: editableData },
			},
			paths: { thumbnailPath, spreadPath },
			version,
			pagesSelection,
			isAccessibleVersion,
		},
	} = state;
	const { tempGId: resourceId } = getClientAndResourceIds();
	const { spread, spreadIndex, activeDraggingPosition } = ownProps;

	let thumbnailsData: ThumbnailData[] = [];

	if (spreadPath && !isAccessibleVersion) {
		const leftPage = thumbnails.items[spread[0]];
		const rightPage = thumbnails.items[spread[1]];
		let selfVersion = leftPage.version || 0;

		if (rightPage) {
			selfVersion += (rightPage.version || 0);
		}

		thumbnailsData.push({
			...thumbnails.items[spread[0]],
			imageSrc: UrlUtils.getEditorResourceUrl(galleryConfig, resourceId, `${getPageHtmlPath(spreadPath, spreadIndex + 1)}?version=${version + selfVersion}`),
		});
	} else if (isAccessibleVersion) {
		const numberOfItems = Object.keys(thumbnails.items).length;

		if (spreadIndex < numberOfItems) {
			thumbnailsData = [{
				...thumbnails.items[spreadIndex + 1],
				extPage: false,
				imageSrc: UrlUtils.getEditorResourceUrl(galleryConfig, resourceId, `${getPageHtmlPath(thumbnailPath, spreadIndex + 1)}?version=${version}`),
			}];
		} else {
			const labelKey = '1';

			thumbnailsData = [{
				extPage: false,
				imageSrc: '',
				label: thumbnails.items[labelKey].label,
				position: spreadIndex + 1,
			}];
		}
	} else {
		thumbnailsData = spread.map((page) => {
			const { position, version: selfVersion = 0 } = thumbnails.items[page];

			return {
				...thumbnails.items[page],
				imageSrc: UrlUtils.getEditorResourceUrl(galleryConfig, resourceId, `${getPageHtmlPath(thumbnailPath, position)}?version=${version + selfVersion}`),
			};
		});
	}

	const isActive = pagesSelection.isActive
		? pagesSelection.spreadIndices.includes(spreadIndex)
		: spreadIndex === currentSpreadIndex;

	return {
		thumbnailsData,
		isActive,
		isEditable: !isAccessibleVersion ? spread.some(page => Object.keys(editableData).includes(page.toString())) : true,
		isPagesSelectionActive: pagesSelection.isActive,
		selectedPagesNumber: isActive ? pagesSelection.spreadIndices.length : undefined,
		activeDraggingPosition: isActive ? activeDraggingPosition : null,
		isAllPagesSelected: pagesSelection.spreadIndices.length === spreads.length,
		isGapInSelectedPages: isActive && SelectionManager.isGapInSelectedItems(pagesSelection.spreadIndices),
		isPagesSelectionAvailable: spreads.length > 1,
		isAccessibleVersion,
	};
};

export default connect(mapStateToProps)(DraggableItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Thumbnails/Column/DraggableItem/index.tsx